/*Splitting();*/
import Parallax from 'parallax-js';

if (document.querySelector('[data-parallax-el]') && window.innerWidth >= 1025) {
  const parallaxContainer = document.querySelectorAll('[data-parallax-el]');
  parallaxContainer.forEach((elem) => {
    let parallaxInstance = new Parallax(elem);
    parallaxInstance.enable();
  });
}

if (document.querySelector('[data-duplicate]')) {
  const originalArr = document.querySelectorAll('[data-original]');
  const duplicateArr = document.querySelectorAll('[data-duplicate]');

  originalArr.forEach((originalElement) => {
    const originalValue = originalElement.dataset.original;
    duplicateArr.forEach((duplicateElement) => {
      const duplicateValue = duplicateElement.dataset.duplicate;
      if (originalValue === duplicateValue) {
        duplicateElement.textContent = originalElement.textContent;
      }
    });
  });
}

document.querySelectorAll('[data-splitting]').forEach((item) => {
  const chars = Splitting({ target: item, by: 'chars' })[0].chars;

  const totalChars = chars.length;
  const baseSpeed = 800;
  const speed = Math.max(15, baseSpeed / totalChars);

  chars.forEach((char, index) => {
    const randomDelay = Math.random() * 10;
    char.style.animationDelay = `${index * speed + randomDelay}ms`;
  });

  // Убираем курсор в конце анимации
  setTimeout(() => {
    item.classList.add('finished');
  }, totalChars * speed);
});



window.initTilt = function initTilt() {
  if (document.querySelector('[data-tilt-init]') && window.innerWidth > 1024) {
    const tiltInitItemsArr = document.querySelectorAll('[data-tilt-init]');
    tiltInitItemsArr.forEach((item) => {
      VanillaTilt.init(item, {
        /*max: 7,*/
        speed: 500,
      });
    });
  }
};
initTilt();

if (document.querySelector('.anime-motion-animation')) {
  const animeMotionAnimElArr = document.querySelectorAll(
    '.anime-motion-animation'
  );
  animeMotionAnimElArr.forEach((animeMotionAnimEl) => {
    const defaultSpeed = 3000;
    const originalSpeed =
      Number(parseFloat(animeMotionAnimEl.getAttribute('data-anime-speed'))) ||
      defaultSpeed;

    const petaAnimation = anime({
      targets: animeMotionAnimEl.querySelector('svg path'),
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: 'easeInOutSine',
      duration: originalSpeed,
      delay: function (el, i) {
        return i * 1;
      },
      direction: 'normal',
      loop: false,
    });
    petaAnimation.pause();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              petaAnimation.play();
              animeMotionAnimEl.classList.add('animated');
            }, 600);
            observer.unobserve(animeMotionAnimEl);
          }
        });
      },
      { threshold: 0, rootMargin: '0% 0% -10% 0%' }
    );

    observer.observe(animeMotionAnimEl);
  });
}
